module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-Black.944c7f13.woff";